const updateNavegacaoSubnivel = ({ commit }, payload) => {
  commit('UPDATE_NAVIGATION_SUBNIVEL', payload)
}

export { updateNavegacaoSubnivel }
